import { ActionReducerMap } from '@ngrx/store';
import { Moment } from 'moment';
import { DsrPayform } from '@xpo-ltl/sdk-linehaulpayform';
import { PayformStatusCd } from '@xpo-ltl/sdk-common';
import { PayformReducer } from './payform/payform.reducers';
import { PayformsFilterReducer } from './payforms-filter/payforms-filter.reducers';

export interface ActionPatchData {
  [key: string]: any;
}

export interface PayformsFilterState {
  sicCd: string;
  employeeName: string;
  fromDate: Moment;
  toDate: Moment;
  status: PayformStatusCd[];
}

export interface PayformState {
  readOnly: boolean; // false if current Payform can be edited
  current: DsrPayform; // currently editable payform
  pristine: DsrPayform; // pristine original copy of current payform
}

/**
 * Define the interface for the App state
 */
export interface AppState {
  payformsFilter: PayformsFilterState;
  payform: PayformState;
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
  payformsFilter: PayformsFilterReducer,
  payform: PayformReducer,
};
